var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelEfficiencyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_242_96952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.3337V6.66699C13.3333 4.30997 13.3333 3.13146 12.6011 2.39923C11.8689 1.66699 10.6904 1.66699 8.33333 1.66699H7.5C5.14298 1.66699 3.96447 1.66699 3.23223 2.39923C2.5 3.13146 2.5 4.30997 2.5 6.66699V18.3337",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91666 8.33301L6.66666 10.4163H9.16666L7.91666 12.4997",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.333H1.66666",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.33301L17.2776 4.15506C17.3924 4.24695 17.4499 4.29289 17.5021 4.33972C17.9948 4.7814 18.2923 5.40039 18.3294 6.06104C18.3333 6.13108 18.3333 6.20463 18.3333 6.35171V15.4163C18.3333 16.1067 17.7737 16.6663 17.0833 16.6663C16.393 16.6663 15.8333 16.1067 15.8333 15.4163V15.3568C15.8333 14.6993 15.3003 14.1663 14.6429 14.1663H13.3333",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.66699H17.0833C16.393 6.66699 15.8333 7.22664 15.8333 7.91699V9.93271C15.8333 10.4707 16.1776 10.9484 16.6881 11.1186L18.3333 11.667",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_242_96952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelEfficiencyDark);
export default __webpack_public_path__ + "static/media/Fuel Efficiency Dark.2f08bcf2944434845ca863a3e431377e.svg";
export { ForwardRef as ReactComponent };